import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {GgwImplementationsService} from '@catmodules/models/ggw-implementations/services/ggw-implementations.service';
import {UIFormModule} from '@catuiform/ui-form.module';

const publicComponents = [];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIFormModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [GgwImplementationsService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class GgwImplementationsModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-implementations/ggw-implementations.module.ts